/* Product page "Offers for you": copy a coupon code, reveal extra offers.
   Delegated on document so it keeps working after a colour swatch swap
   re-renders the product section. */
(function () {
  if (window.ORWProductOffers) return;
  window.ORWProductOffers = true;

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.className = 'orw-product-offers__clipboard';
    document.body.appendChild(field);
    field.select();
    try { document.execCommand('copy'); } catch (err) { /* ignore */ }
    document.body.removeChild(field);
    return Promise.resolve();
  }

  document.addEventListener('click', function (e) {
    var codeBtn = e.target.closest('[data-orw-offer-copy]');
    if (codeBtn) {
      var action = codeBtn.querySelector('[data-orw-offer-action]');
      var label = action ? action.textContent : '';
      copyText(codeBtn.getAttribute('data-orw-offer-copy')).then(function () {
        codeBtn.classList.add('is-copied');
        if (action) action.textContent = codeBtn.getAttribute('data-orw-copied-label') || 'Copied';
        clearTimeout(codeBtn._orwTimer);
        codeBtn._orwTimer = setTimeout(function () {
          codeBtn.classList.remove('is-copied');
          if (action) action.textContent = label;
        }, 2000);
      });
      return;
    }

    var moreBtn = e.target.closest('[data-orw-offers-more]');
    if (moreBtn) {
      var root = moreBtn.closest('[data-orw-offers]');
      if (!root) return;
      root.querySelectorAll('[data-orw-offer-extra]').forEach(function (item) {
        item.hidden = false;
      });
      moreBtn.setAttribute('aria-expanded', 'true');
      moreBtn.hidden = true;
    }
  });
})();
